module.exports = __webpack_public_path__ + "img/ONX.ca7efe26.png";